<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  data() {
    return {
      arrayFields: ['items']
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Nagłówek',
              modelPath: [this, 'form', 'header'],
              required: false,
              multilingual: true
            }),
            new fields.Header({
              text: 'Wątki',
              type: 'h4'
            }),
            new fields.Formset({
              modelPath: [this, 'form', 'items'],
              items: this.form.items.map((item, i) => ({
                headerLabel: `Wątek ${i + 1}`,
                fields: [
                  new fields.Input({
                    label: 'Tytuł',
                    modelPath: [this, 'form', 'items', i, 'title'],
                    required: true,
                    multilingual: true
                  }),
                  new fields.WYSIWYG({
                    label: 'Lead',
                    modelPath: [this, 'form', 'items', i, 'text'],
                    required: true,
                    multilingual: true,
                    type: 'faqWidgetEditorInit'
                  })
                ]
              }))
            })
          ]
        }
      ]
    }
  }
}
</script>
